import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { OrderService } from './order.service';

export const Ng1OrderModule = angular
  .module('control-room.shared.services.order', [])
  .factory('crOrderServiceNew', downgradeInjectable(OrderService));
